import { writable } from 'svelte/store';
import collect from 'collect.js';
import AdminUser from '@/Models/AdminUser';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	let meta;

	const { subscribe, set, update } = writable(collect());

	const methods = {
		getPagination() {
			return meta && meta.pagination;
		},

		getAdminUsers(pagination = null) {
			let adminUser = new AdminUser();

			let results = pagination ? adminUser.paginate(pagination.size, pagination.number) : adminUser.get();
			return results.then((result) => {
				meta = result.meta;
				set(collect(result.data));
			});
		},

		getAdminUser(adminUserId) {
			let adminUser = new AdminUser();

			return adminUser.find(adminUserId).then((result) => {
				set(collect([result]));
			});
		},

		patchData(adminUserId, data) {
			let adminUser = new AdminUser();

			return adminUser.patchData(adminUserId, data);
		},

		patchCurrent(data) {
			let adminUser = new AdminUser();

			return adminUser.patchCurrent(data);
		},

		updateAuthUserPassword(data) {
			let adminUser = new AdminUser();

			return adminUser.updateAuthUserPassword(data);
		},

		createAdminUser(formData) {
			let adminUser = new AdminUser();

			return adminUser.makePersistRequest({
				url: `${adminUser.baseUrl()}/${adminUser.resourceName()}/`,
				method: 'POST',
				data: formData
			});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
